import render from './render'

/**
 * Элемент списка регионов стран.
 */
export default {
  name: 'Item',

  props: {
    /**
     * Запись региона страны.
     * Поля записи выводятся стикерами, название региона ведёт на страницу записи.
     *
     * @type {object}
     * @default {}
     */
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
